// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","credit-card-details":"_3QAXA5rqRJwxidpr9wEG8m","bold":"_c5dYy8v-1ePC3PlJGC_f","credit-card-icon":"C-A0ki1c6skuB5ij4alw6"};